module.exports = __webpack_public_path__ + "assets/img/heart.f65a11d5.png";